<app-content
    contentTitle="{{ 'translate_approval_and_suggestions' | translate }}"
>
    <!-- Tools -->
    <ng-container tools>
        <button
            (click)="period.isApproved ? disapprove() : approve()"
            class="btn btn-sm btn-white"
            [disabled]="loadingStatus.approval"
        >
            @if (loadingStatus.approval) {
                <app-loading-ring class="me-2"></app-loading-ring>
            }
            <span>
                {{
                    (period.isApproved
                        ? 'translate_disapprove'
                        : 'translate_approve'
                    ) | translate
                }}
            </span>
        </button>
    </ng-container>

    <!-- Content -->
    <div content class="flex flex-col items-stretch gap-2 md:flex-row">
        <div class="flex flex-1 flex-col gap-2">
            <label>{{ 'translate_supervisor_notes' | translate }}</label>
            <textarea
                [(ngModel)]="period.supervisorNote"
                name="supervisorNote"
                cols="30"
                rows="10"
            ></textarea>
            <button
                (click)="saveSupervisorNote()"
                class="btn btn-primary"
                [disabled]="loadingStatus.notes"
            >
                @if (loadingStatus.notes) {
                    <app-loading-ring class="me-2"></app-loading-ring>
                }
                <span>
                    {{ 'translate_save' | translate }}
                </span>
            </button>
        </div>
        <div class="flex flex-1 flex-col gap-2">
            <label>{{ 'translate_leadership_directives' | translate }}</label>
            <textarea
                [(ngModel)]="period.leadershipDirective"
                name="leadershipDirective"
                cols="30"
                rows="10"
            ></textarea>
            <button
                (click)="saveLeadershipDirective()"
                class="btn btn-primary"
                [disabled]="loadingStatus.directives"
            >
                @if (loadingStatus.directives) {
                    <app-loading-ring class="me-2"></app-loading-ring>
                }
                <span>
                    {{ 'translate_save' | translate }}
                </span>
            </button>
        </div>
    </div>
</app-content>
